export const ACTIVISM_CATEGORY_ID = '3';
export const NEWS_LONG_SHORT = 'L';
export const PAGE_SIZE = 20;

export const NEWS_TAG_WEEKLY_WRAP = 'Weekly wrap';
export const NEWS_TAG_COVID_19 = 'COVID-19';
export const NEWS_TAG_THIS_WEEK = 'Activism & Voting this week';
export const NEWS_TAG_IN_DEPTH = 'In-depth';
export const VOTING_NEWS_TAG_IN_DEPTH = 'Voting In-depth';
export const ACTIVIST_SHORTS_NEWS_TAG_IN_DEPTH = 'Shorts In-depth';
export const ACTIVISM_NEWS_TAG_IN_DEPTH = 'Activism In-depth';
export const COMPENSATION_NEWS_TAG_IN_DEPTH = 'Compensation In-depth';

export const NEWS_TAG_VULNERABILITY_HIT = 'Vulnerability Hit';
export const NEWS_TAG_VULNERABILITY_UPDATE = 'Vulnerability Update';

export const PAST_WEEK = 'Past Week';
export const PAST_WEEK_VALUE = '-7';
export const PAST_FORTNIGHT = 'Past Fortnight';
export const PAST_FORTNIGHT_VALUE = '-14';
export const PAST_MONTH = 'Past Month';
export const PAST_MONTH_VALUE = '-1';
export const PAST_THREE_MONTHS = 'Past 3 Months';
export const PAST_THREE_MONTHS_VALUE = '-3';
export const SPECIFY_PERIOD = 'Specify Period';
export const SPECIFY_PERIOD_VALUE = '';
export const ALL_TIME = 'All Time';
export const ALL_TIME_VALUE = 'a';

export const NEWS_DEFAULT_IMG_PATH = '/images/logo/LogoStandardSmall.png';
export const PROFILE_DEFAULT_IMG_PATH = '/images/user.jpg';

export default {
  ACTIVISM_CATEGORY_ID,
  NEWS_LONG_SHORT,
  NEWS_TAG_WEEKLY_WRAP,
  NEWS_TAG_COVID_19,
  NEWS_TAG_THIS_WEEK,
  NEWS_TAG_IN_DEPTH,
  PAGE_SIZE,
  PAST_WEEK,
  PAST_FORTNIGHT,
  PAST_MONTH,
  PAST_THREE_MONTHS,
  SPECIFY_PERIOD,
  ALL_TIME,
  PAST_WEEK_VALUE,
  PAST_FORTNIGHT_VALUE,
  PAST_MONTH_VALUE,
  PAST_THREE_MONTHS_VALUE,
  SPECIFY_PERIOD_VALUE,
  ALL_TIME_VALUE,
  NEWS_DEFAULT_IMG_PATH,
  NEWS_TAG_VULNERABILITY_HIT,
  NEWS_TAG_VULNERABILITY_UPDATE,
  PROFILE_DEFAULT_IMG_PATH,
  VOTING_NEWS_TAG_IN_DEPTH,
  ACTIVIST_SHORTS_NEWS_TAG_IN_DEPTH,
  ACTIVISM_NEWS_TAG_IN_DEPTH,
  COMPENSATION_NEWS_TAG_IN_DEPTH,
};
